import { useFormContext } from '@/contexts/form-context';
import { useModal } from '@/hooks/shared/use-modal';

export default function ButtonGroup() {
  const { close } = useModal();
  const form = useFormContext();

  return (
    <div className="flex flex-wrap justify-end space-x-2">
      <button
        type="button"
        className="btn border-gray-200 dark:border-gray-700/60 hover:border-gray-300 dark:hover:border-gray-600 text-gray-800 dark:text-gray-300"
        onClick={(e) => {
          e.stopPropagation();
          form.reset();
          close();
        }}
      >
        Avbryt
      </button>
      <form.Subscribe
        selector={(state) => [state.canSubmit, state.isSubmitting]}
        children={([canSubmit, isSubmitting]) => (
          <button
            disabled={!canSubmit}
            type="submit"
            className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"
          >
            {isSubmitting ? 'Lägger till...' : 'Lägg till'}
          </button>
        )}
      />
    </div>
  );
}
